<template>
  <form data-vv-scope="bank">
    <!--bank Account-->
    <div class="form-group">
      <label
        class="control-label requiredField"
        for="vendor-signup-bankAcc"
        data-test="vendorGstFormAc"
        id="vendorGstFormAc"
      >
        Bank A/C No.
        <span class="asteriskField" data-test="vendorGstFormAcSpan"
														id="vendorGstFormAcSpan">*</span>
      </label>
      <input
        class="form-control"
        v-validate="'required|min:10|max:18|numeric'"
        type="text"
        :class="(showSignUpError &&
                            errors.has('bank.bankAcc'))?'is-invalid':''"
        name="bankAcc"
        placeholder="Bank Account"
        v-model="account.account_number"
        id="vendor-signup-bankAcc"
        autocomplete="off"
        data-ismobileonly="false"
        :disabled="isDisabled"
        data-test="vendorGstFormAcInput"
      />
      <div
        class="invalid-feedback"
        v-if="showSignUpError"
        v-show="errors.has('bank.bankAcc')"
        id="vendor-signup-bankAcc-error"
        data-test="vendorGstFormAcError"
      >{{errors.first('bank.bankAcc')}}</div>
    </div>

    <!--IFSC code-->
    <div class="form-group">
      <label
        class="control-label requiredField"
        for="vendor-signup-ifscCode"
        data-test="vendorGstFormIfsc"
        id="vendorGstFormIfsc"
      >
        IFSC Code
        <span class="asteriskField" data-test="vendorGstFormIfscSpan"
														id="vendorGstFormIfscSpan">*</span>
      </label>
      <input
        class="form-control"
        v-validate="'required'"
        :class="(showSignUpError &&
                      errors.has('bank.ifscCode'))|| ifscError?'is-invalid':''"
        data-ismobileonly="false"
        name="ifscCode"
        type="text"
        maxlength="11"
        placeholder="IFSC Code"
        v-model="account.ifsc_code"
        id="vendor-signup-ifscCode"
        autocomplete="off"
        @keyup="isAlphaNum($event)"
        @paste="cleanNonAlpha"
        @blur="ifscCodeData(account.ifsc_code)"
        :disabled="isDisabled"
        data-test="vendorGstFormIfscInput"
      />
      <div
        style="color: #dc3545;
                  margin-top: 0.25rem;
                  font-size: 80%;
                  width: 100%"
        v-if="ifscError"
        data-test="vendorGstFormIfscError1"
        id="vendorGstFormIfscError1"
      >Invalid ifscCode</div>
      <div
        class="invalid-feedback"
        v-if="showSignUpError"
        v-show="errors.has('bank.ifscCode')"
        id="vendor-signup-ifscCode-error"
        data-test="vendorGstFormIfscError2"
      >{{errors.first('bank.ifscCode')}}</div>
    </div>

    <!--BranchName-->
    <div class="form-group">
      <label
        class="control-label requiredField"
        for="vendor-sign-up-branchName"
        data-test="vendorGstFormBranch"
        id="vendorGstFormBranch"
      >
        Branch Name
        <span class="asteriskField" data-test="vendorGstFormBranchSpan"
														id="vendorGstFormBranchSpan">*</span>
      </label>
      <input
        class="form-control"
        v-validate="'required'"
        :class="(showSignUpError &&
                      errors.has('bank.branchName'))?'is-invalid':''"
        name="branchName"
        type="text"
        placeholder="Branch Name"
        v-model="account.branch_name"
        id="vendor-sign-up-branchName"
        data-ismobileonly="false"
        autocomplete="off"
        :disabled="isDisabled"
        data-test="vendorGstFormBranchInput"
      />
      <div
        class="invalid-feedback"
        v-if="showSignUpError"
        v-show="errors.has('bank.branchName')"
        id="vendor-sign-up-branchName-error"
        data-test="vendorGstFormBranchError"
      >{{errors.first('bank.branchName')}}</div>
    </div>

    <!--BankName-->
    <div class="form-group">
      <label
        class="control-label requiredField"
        for="vendor-sign-up-bankName"
        data-test="vendorGstFormBnk"
        id="vendorGstFormBnk"
      >
        Bank Name
        <span class="asteriskField" data-test="vendorGstFormBnkSpan"
														id="vendorGstFormBnkSpan">*</span>
      </label>
      <input
        class="form-control"
        v-validate="'required'"
        :class="(showSignUpError &&
                      errors.has('bank.bankName'))?'is-invalid':''"
        name="bankName"
        type="text"
        placeholder="Bank Name"
        v-model="account.bank_name"
        id="vendor-sign-up-bankName"
        data-ismobileonly="false"
        autocomplete="off"
        :disabled="isDisabled"
        data-test="vendorGstFormBnkInput"
      />
      <div
        class="invalid-feedback"
        v-if="showSignUpError"
        v-show="errors.has('bank.bankName')"
        id="vendor-sign-up-bankName-error"
        data-test="vendorGstFormBnkError"
      >{{errors.first('bank.bankName')}}</div>
    </div>

    <!--AccountHolderName-->
    <div class="form-group">
      <label
        class="control-label requiredField"
        for="vendor-sign-up-accHolderName"
        data-test="vendorGstFormAcName"
        id="vendorGstFormAcName"
      >
        Account Holder Name
        <span class="asteriskField" data-test="vendorGstFormAcNameSpan"
														id="vendorGstFormAcNameSpan">*</span>
      </label>
      <input
        class="form-control"
        v-validate="'required'"
        :class="(showSignUpError &&
                           errors.has('bank.accHolderName'))?'is-invalid':''"
        name="accHolderName"
        type="text"
        placeholder="Account Holder Name"
        v-model="account.account_holder_name"
        id="vendor-sign-up-accHolderName"
        data-ismobileonly="false"
        autocomplete="off"
        :disabled="isDisabled"
        data-test="vendorGstFormAcNameInput"
      />
      <div
        class="invalid-feedback"
        v-if="showSignUpError"
        v-show="errors.has('bank.accHolderName')"
        id="vendor-sign-up-accHolderName-error"
        data-test="vendorGstFormAcNameError"
      >{{errors.first('bank.accHolderName')}}</div>
    </div>

    <!--cancelled cheque leaf Upload-->
    <div class="form-group" v-if="!isDisabled">
      <label
        class="control-label requiredField"
        for="inputGroupFile011"
        data-test="vendorGstFormCheque"
        id="vendorGstFormCheque"
      >Cancelled cheque leaf</label>
      <div class="input-group mb-3">
        <div class="input-group-prepend">
          <span
            class="input-group-text"
            id="inputGroupFileAddon01"
            data-test="vendorGstFormUploadSpan"
          >Upload</span>
        </div>
        <div class="custom-file">
          <input
            type="file"
            name="fileupload"
            class="custom-file-input"
            id="inputGroupFile011"
            accept="image/*"
            v-validate="'ext:jpg,png,pdf'"
            :class="(showSignUpError &&
                          errors.has('bank.fileupload'))?'is-invalid':''"
            @change="uploadImages"
            aria-describedby="inputGroupFileAddon01"
            data-test="vendorGstFormChequeInput"
          />
          <label
            class="custom-file-label"
            for="inputGroupFile011"
            data-test="vendorGstFormFileName"
            id="vendorGstFormFileName"
          >{{this.fileName? this.fileName : 'Choose file'}}</label>
          <div
            class="invalid-feedback"
            v-if="showSignUpError"
            v-show="errors.has('bank.fileupload')"
            id="vendor-bankForm-fileUpload-error"
            data-test="vendorGstFormChequeError"
          >{{errors.first('bank.fileupload')}}</div>
        </div>
      </div>
    </div>

    <div class="form-group" v-if="!isDisabled">
      <label for="vendor-kyc-checkbox" class="text-left d-block main_checkBoxcontainer">
        <input
          class="mr-2"
          name="checkbox"
          id="vendor-kyc-checkbox"
										data-test="vendorGstFormUpdate"
          type="checkbox"
          v-model="checkbox"
          @change="checkboxEvent"
          :disabled="updateKycCheckboxDisable"
        />
        Update KYC deatils Now
        <span class="checkmark"></span>
      </label>
    </div>

    <div v-if="showKYCForm && !isDisabled">
      <div class="form-group">
        <label class="control-label requiredField" for="exampleInputAadhar"
															data-test="vendorGstFormAadharNumber"
															id="vendorGstFormAadharNumber">Aadhar Number</label>
        <input
          type="text"
          class="form-control"
          id="exampleInputAadhar"
          aria-describedby="emailHelp"
          placeholder="Aadhar Number"
          name="aadhar-number"
          v-model="account.kyc_details[0].value"
          v-validate="'required|numeric|min:12|max:12'"
          :class="(showSignUpError &&
                        errors.has('bank.aadhar-number'))?'is-invalid':''"
          data-test="applyKycFormAadharInput"
        />
        <div
          class="invalid-feedback"
          v-if="(errors.has('bank.aadhar-number') && showSignUpError)"
          style="display: block;"
          id="aadhar-error"
          data-test="applyKycFormAaadharInputError"
        >{{ errors.first('bank.aadhar-number') }}</div>
      </div>

      <div class="form-group">
        <label class="control-label requiredField" for="exampleInputPanNumber">Pan Number</label>
        <input
          type="text"
          class="form-control"
          id="exampleInputPanNumber"
          placeholder="Pan Number"
          name="pan-number"
          v-model="account.kyc_details[1].value"
          v-validate="'required|alpha_num|min:10|max:10'"
          :class="(showSignUpError &&
                        errors.has('bank.pan-number'))?'is-invalid':''"
          data-test="applyKycFormPanInput"
        />
        <div
          class="invalid-feedback"
          v-if="(errors.has('bank.pan-number') && showSignUpError)"
          style="display: block;"
          id="apply-pan-error"
          data-test="applyKycPanInputError"
        >{{ errors.first('bank.pan-number') }}</div>
      </div>

      <!--Upload document-->
      <div class="form-group">
        <label
          class="control-label requiredField"
          for="inputGroupFile011"
										data-test="vendorGstFormUpload"
										id="vendorGstFormUpload"
        >Upload Document(Aadhar or Pan)</label>
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="inputGroupFileAddon02"
																		data-test="inputGroupFileAddon02">Upload</span>
          </div>
          <div class="custom-file">
            <input
              type="file"
              name="document fileupload"
              class="custom-file-input"
              id="inputGroupFile012"
              data-test="inputGroupFile012"
              accept="image/*"
              v-validate="'required|ext:jpg,png,pdf'"
              :class="(showSignUpError &&
                             errors.has('bank.document fileupload'))?'is-invalid':''"
              @change="uploadDoc"
              aria-describedby="inputGroupFileAddon01"
            />
            <label
              class="custom-file-label"
              for="inputGroupFile011"
														data-test="vendorGstFormDocFile"
														id="vendorGstFormDocFile"
            >{{this.docfileName? this.docfileName : 'Choose file'}}</label>
          </div>
        </div>
        <div
          class="invalid-feedback"
          v-if="showSignUpError"
          v-show="errors.has('bank.document fileupload')"
          id="vendor-bankForm-docUpload-error"
          data-test="vendor-bankForm-docUpload-error"
          style="display: block;"
        >{{errors.first('bank.document fileupload')}}</div>
      </div>
      <div class>
        <small
          class="control-label requiredField"
          style="color: red;"
										data-test="vendorGstFormKYCUpdate"
										id="vendorGstFormKYCUpdate"
        >*Update KYC form to add products</small>
      </div>
    </div>

    <!--View KYC details-->
    <div v-if="isDisabled && account.kyc_details && account.kyc_details.length>0">
      <hr />
      <h6 data-test="vendorGstFormKYCDetails"
										id="vendorGstFormKYCDetails">KYC Details</h6>
      <hr />
      <div class="form-group" v-for="(kycDetails, index) in account.kyc_details" :key="index">
        <label class="control-label requiredField" for="'vendor-kyc-details'+index"
															data-test="vendorGstFormKYCDetailsKey"
															id="vendorGstFormKYCDetailsKey"
								>
          {{kycDetails.key}}
          <span class="asteriskField"
																data-test="vendorGstFormKYCDetailsKeySpan"
																id="vendorGstFormKYCDetailsKeySpan">*</span>
        </label>
        <input
          class="form-control"
          name="accHolderName"
          type="text"
          v-model="kycDetails.value"
          :id="'vendor-kyc-details'+index"
          :data-test="'vendor-kyc-details'+index"
          data-ismobileonly="false"
          autocomplete="off"
          :disabled="isDisabled"
        />
      </div>
    </div>

    <div class="modal-footer">
      <button
        type="submit"
        @click.prevent="action('bank')"
        class="btn btn-primary"
								data-test="vendorGstFormBtn"
								id="vendorGstFormBtn"
      >{{isDisabled?'Close':'Save changes'}}</button>
    </div>
  </form>
</template>

<script>
import { globalApis } from '../../../../services/ApiServices/globalApis'
// import { vendorApis } from '../../../../services/ApiServices/vendorApis'
import { vendorCommon } from '../../../../commonJs/vendorAndAgent'
// import KycForm from './KycForm';

export default {
	// components: { KycForm },
	data () {
		return {
			account: {
				account_number: Number,
				document_url: '',
				kyc_details: []
			},
			branch: '',
			bank: '',
			showSignUpError: false,
			ifscError: false,
			fileName: '',
			showKYCForm: false,
			docfileName: '',
			checkbox: false,
			confirmKyc: false,
			updateKycCheckboxDisable: false
		}
	},
	methods: {
		action (scope) {
			this.$validator.validateAll(scope).then(result => {
				if (result && !this.ifscError) {
					if (this.isDisabled === true) {
						$('#gstModal').modal('hide')
					} else if (this.checkbox === false) {
						if (
							confirm('Are you sure to proceed without updating KYC details?')
						) {
							this.showSignUpError = false
							// this.ifscCodeData(this.account.ifscCode);
							this.account.branch_name = this.branch
							this.account.bank_name = this.bank
							// const notFoundIndexes = [];
							// if (this.account && this.account.kyc_details && this.account.kyc_details.length > 0) {
							//   this.account.kyc_details.forEach((doc, index) => {
							//     if (doc.value === '') {
							//       notFoundIndexes.push(index);
							//     }
							//   });
							// }
							// if (notFoundIndexes.length > 0) {
							//   notFoundIndexes.forEach((index) => {
							//     this.account.kyc_details.splice(index, 1);
							//   });
							// }
							// this.account.kyc_details = [];
							// delete this.account.kyc_details;
							this.$emit('bankDetailsSubmit', this.account)
							this.docfileName = ''
							this.account.document_url = ''
							$('#gstModal').modal('hide')
						} else {
							this.showSignUpError = false
							// this.ifscCodeData(this.account.ifscCode);
							this.account.branch_name = this.branch
							this.account.bank_name = this.bank
							// this.$emit('bankDetailsSubmit', this.account);
							$('#gstModal').modal('show')
						}
					} else {
						this.showSignUpError = false
						// this.ifscCodeData(this.account.ifscCode);
						this.account.branch_name = this.branch
						this.account.bank_name = this.bank
						this.$emit('bankDetailsSubmit', this.account)
						this.docfileName = ''
						this.account.document_url = ''
						$('#gstModal').modal('hide')
						// this.gstDataSubmit(this.account);
					}
				} else {
					this.showSignUpError = true
					// this.ifscCodeData(this.account.ifscCode);
				}
			})
		},
		bindExistingBankDetails () {
			const localAccountobj = this.account
			const propGstData = this.gstData
			this.account = { ...localAccountobj, ...propGstData }
			this.bank = this.gstData.bank_name
			this.branch = this.gstData.branch_name
			if (this.account.kyc_details && this.account.kyc_details.length > 0) {
				setTimeout(() => {
					$('#vendor-kyc-checkbox')[0].checked = true
				}, 800)
				this.showKYCForm = true
				this.checkbox = true
				this.updateKycCheckboxDisable = true
			}
			if (this.account === (null || undefined)) {
				this.account = {
					account_number: '',
					account_holder_name: ''
				}
			}
		},
		isAlphaNum (e) {
			const k = document.all ? e.keycode : e.which
			if (
				(k > 47 && k < 58) ||
        (k > 64 && k < 91) ||
        (k > 96 && k < 123) ||
        k === 0
			) {
				if (
					this.account.ifsc_code.length ===
          document.getElementById('vendor-signup-ifscCode').maxLength
				) {
					this.ifscCodeData(this.account.ifsc_code)
				}
				return true
			}
			e.preventDefault()
			return false
		},
		cleanNonAlpha (e) {
			let pastedText = ''
			if (window.clipboardData && window.clipboardData.getData) {
				pastedText = window.clipboardData.getData('Text')
			} else if (e.clipboardData && e.clipboardData.getData) {
				pastedText = e.clipboardData.getData('text/plain')
			}
			this.account.ifsc_code = pastedText.replace(/[^A-Za-z0-9]+/g, '')
			if (this.account.ifsc_code) {
				this.ifscCodeData(this.account.ifsc_code)
			}
		},
		ifscCodeData (code) {
			if (code) {
				globalApis
					.ifscCodeData(code)
					.then(res => {
						this.branch = res.data.BRANCH
						this.bank = res.data.BANK
						this.account.branch_name = res.data.BRANCH
						this.account.bank_name = res.data.BANK
						this.ifscError = false
						this.$forceUpdate()
					})
					.catch(e => {
						// this.$toasted.error('Invalid ifscCode');
						this.ifscError = true
						this.$forceUpdate()
					})
			}
		},
		async uploadImages (event) {
			this.account.cancelled_check = await vendorCommon.imageUploader(event)
			if (this.account.cancelled_check !== '') {
				this.fileName = event.target.files[0].name
			}
		},
		async uploadDoc (event) {
			this.account.document_url = await vendorCommon.imageUploader(event)
			if (this.account.document_url !== '') {
				this.docfileName = event.target.files[0].name
			}
		},
		checkboxEvent (evt) {
			if (evt.target.checked === true) {
				this.showKYCForm = true
				this.account.kyc_details = [
					{
						key: 'Aadhar Number',
						value: ''
					},
					{
						key: 'Pan Number',
						value: ''
					}
				]
			} else {
				this.showKYCForm = false
				this.account.kyc_details = []
				this.docfileName = ''
				this.account.document_url = ''
			}
		}
	},
	mounted () {
		this.bindExistingBankDetails()
	},
	props: {
		gstData: {},
		isDisabled: {
			type: Boolean,
			default: false
		}
	},
	watch: {
		gstData () {
			this.bindExistingBankDetails()
		}
	}
}
</script>
